export const IMPERSONATED_ZEZAM_ID_KEY = 'impersonat_zezam_id'
export const IMPERSONATED_ZEZAM_USER_QUERY_PARAM = 'as-user-id'
export const IMPERSONATE_USER_HEADER_NAME = 'X-Impersonate-User'
